import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-outstanding-statistics',
  templateUrl: './outstanding-statistics.component.html',
  styleUrls: ['./outstanding-statistics.component.scss']
})
export class OutStandingStatistics implements OnInit {

  @Input() dataReport: any
  title_report = 'Thống kê nổi bật';
  result = [];
  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  mappingData() {
    if(this.dataReport && this.dataReport.data && this.dataReport.data.result) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      } else {
        this.title_report = `${this.title_report} ${this.dataReport.data.time}`;
      }
      this.result = this.dataReport.data.result;
      console.log(this.result)
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/outstanding-statistics/outstanding-statistics.component.ts